























import {Component, Vue} from 'vue-property-decorator';
import SerialNumberCheck from '@/components/snapshot/SerialNumberCheck.vue';
import Spinner from '@/layouts/back-office/elements/Spinner.vue';
import RecaptureAICheck from '@/components/snapshot/RecaptureAICheck.vue';

@Component({
  components: {RecaptureAICheck, SerialNumberCheck, Spinner},
})
export default class RecaptureAIAudit extends Vue {
  private next() {
    ((this.$refs.query as any).getApolloQuery() as any).refetch();
  }
}
